import * as accessToken from './accessToken';
import * as arrays from './arrays';
import * as client from './client';
import * as colors from './colors';
import * as dates from './dates';
import * as dtoParsers from './dtoParsers';
import * as files from './files';
import * as numbers from './numbers';
import * as objects from './objects';
import * as periods from './periods';
import * as sort from './sort';
import * as strings from './strings';
import * as time from './time';
import * as url from './url';
import * as validations from './validations';
export default {
    accessToken,
    arrays,
    client,
    colors,
    dates,
    dtoParsers,
    files,
    numbers,
    objects,
    periods,
    sort,
    strings,
    time,
    url,
    validations
};
